import { ComplianceStatus } from '../../types';
import {
  FilledCompliance,
  TenantComplianceForm,
} from '../../../../../../backend-core-lib/app/common-shared/account/models';
import { find } from 'lodash';
import { decompressAndDecodeData } from '../../../../common-shared/utils';
import { evaluateFormlyExpression } from '../../../../common-shared/forms';
import { requiresComplianceFormManualApproval } from './requires-compliance-form-manual-approval';

export function getComplianceStatus(
  filledCompliance: FilledCompliance[],
  complianceForms: TenantComplianceForm[],
): ComplianceStatus {
  // If no active complianceForms defined return 'YES'
  const firstActiveComplianceForm = find(complianceForms, { isActive: true });
  if (!firstActiveComplianceForm) {
    return 'YES';
  }

  // If active complianceForms defined:
  // - Get the active filledCompliance
  // - If no active then 'NO'
  // - If active:
  //  - If manuallyApprovedAt return 'YES'
  //  - Get the same complianceForm with the uid and check if manual approval needed
  //    - If needed: then 'PENDING'
  //    - If not needed: then 'YES'
  const activeFilledCompliance = find(filledCompliance, { isActive: true });
  if (!activeFilledCompliance) {
    return 'NO';
  }

  if (activeFilledCompliance.manuallyApprovedAt) {
    return 'YES';
  }

  const originalComplianceForm = find(complianceForms, {
    uid: activeFilledCompliance.formUid,
  });

  if (!originalComplianceForm) {
    return 'NO';
  } else {
    const requiresManualApproval = requiresComplianceFormManualApproval(
      originalComplianceForm,
      activeFilledCompliance,
    );
    return requiresManualApproval ? 'PENDING' : 'YES';
  }
}
